<template>
  <v-list-item class="select-limit-msg">
    <template #prepend>
      <v-icon>mdi-alert</v-icon>
    </template>
    <v-list-item-title>
      Only {{ limit }} selection{{ limit === 1 ? ' is' : 's' }} allowed
    </v-list-item-title>
  </v-list-item>
</template>

<script>
export default {
  name: 'SelectLimitListItem',
  props: {
    limit: {
      type: Number,
      required: false,
      default: null
    }
  }
};
</script>

<style lang="scss">
.select-limit-msg {
  border-top-color: lightgrey;
  position: fixed;
  bottom: 0;
  width: 100%;
  text-align: center;
  justify-content: center;
  background-color: $color-warning-40;
}
</style>
